module.exports = __webpack_public_path__ + "static/media/experience_2.40d615c3.svg";